module.exports = __webpack_public_path__ + "static/media/instructivoa3.36e668ec.png";